import React from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import type { LexicalEditor } from 'lexical'

/**
 * Lexical plugin used for allowing an outer component to access the LexicalEditor object via a React Ref object.
 * Allows an outer component to call methods on the lexical object.
 *
 * This is useful for manually getting the JSON representation of the editor state when clicking on the save button,
 * avoiding the need to save the editor state in a React state when the editor's content change.
 */
export const RefPlugin = React.forwardRef<LexicalEditor | null>((_, ref) => {
    const [editor] = useLexicalComposerContext()
    React.useEffect(() => {
        const editorRef = ref as React.MutableRefObject<LexicalEditor>

        editorRef.current = editor
        return () => {
            editorRef.current = null
        }
    }, [editor, ref])

    return null
})
